<template>
  <div>
    <div
      class="venue-title-bar"
      :style="pageTitleBar"
    >
      <div class="venue-title">
        {{  screenConfig ? screenConfig.screenName : '' }}
      </div>

      <div
        v-if="uploadedImageName"
        class="venue-image"
      >
        <img
          :src="uploadedImagePath"
          alt=""
        >
      </div>
      <div class="the-time">
        {{ screenTime }}
      </div>
    </div>

    <Ticker />

    <div class="flex-race-container">
      <div
        v-for="(venue, index) in venues"
        :key="index"
        class="flex-race-item"
        :class="{ noedge:venue.index % 3 === 0 }"
      >
        <div
          class="race-title-bar"
          :style="raceTitleBar"
        >
          <div class="race-venue-flag">
            <img
              :src="flagImage(venue.countryName)"
              alt=""
            >
          </div>

          <div class="race-venue-name">
            <div class="venue-name">
              {{ venueDisplayName(venue.ve) }}
            </div>
            <div
              v-if="venue.races.length"
              class="race-name"
            >
              {{ venue.races[0].fn | race }} - {{ raceTime(venue.races[0].raceDateTime) }}
            </div>
          </div>

          <div class="race-titles">
            <div class="place-title">
              PLACE
            </div>

            <div class="prev-title">
              PREV
            </div>

            <div class="price-title">
              PRICE
            </div>

            <div
              v-if="venue.races.length"
              class="race-places-paid"
            >
              {{ venue.races[0].placesPaid }} PLACES PAID
            </div>
          </div>

          <div class="clearfix" />
        </div>

        <div
          v-if="venue.races.length"
          class="markets-container"
        >
          <template v-for="market in venue.races[0].markets">
            <template v-if="market.marketId">
              <Market
                v-if="market.include"
                :key="market.id"
                :places-paid="venue.races[0].placesPaid"
                :place-percentage="venue.races[0].placePercentage"
                :venue-id="venue.venueId"
                :race-id="venue.races[0].raceId"
                :market-id="market.marketId"
                :venue-index="index + 1"
              />
            </template>
          </template>

          <Market
            :scroll-markets="venue.races[0].scrollMarkets"
            :places-paid="venue.races[0].placesPaid"
            :place-percentage="venue.races[0].placePercentage"
            :venue-id="venue.venueId"
            :race-id="venue.races[0].raceId"
            :venue-index="index + 1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import venuemixin from '../mixins/venuemixin';
import Market from '@/components/Market';
import Ticker from '@/components/Ticker';

export default {
  name: 'Nextthree',
  components: {
    Market,
    Ticker
  },
  filters: {
    race(input) {
      if (input) {
        input = 'Race ' + input.substring(input.indexOf('.R'), input.length).replace('.R0', '')
          .replace('.R', '');

        return input;
      }
    }
  },
  mixins: [venuemixin],
  data() {
    return {
      screenTime: ''
    };
  },
  computed: {
    venues() {
      const screenData = this.$store.state.screenData;

      if (screenData && screenData.length) {
        return screenData;
      }

      return [];
    },
    marketContainerHeightVenue() {
      return this.$store.getters.marketContainerHeightVenue;
    },
    pageTitleBar() {
      return this.$store.getters.pageTitleBar;
    },
    raceTitleBar() {
      return this.$store.getters.raceTitleBar;
    },
    uploadedImagePath() {
      return `${this.$store.state.webUrl}/uploads/${this.$store.state.screenConfig.uploadedImageName}`;
    },
    uploadedImageName() {
      return this.$store.state.screenConfig.uploadedImageName;
    },
    screenConfig() {
      return this.$store.getters.screenConfig;
    },
  },
  created() {
    setInterval(() => {
      this.screenTime = moment.utc().add(2, 'hours').format('HH:mm:ss');
    }, 1000);

    // Every 60 seconds, check if any races are in the past, or if there are no races left.
    // If either are the case, refresh the feed.
    setInterval(() => {
      if (this.venues.length) {
        if (this.venues[0].races.length) {
          if (moment(this.venues[0].races[0].raceDateTime) < (moment(this.currentDateTime()))) {
            this.refresh();
          } else {
          }
        } else {
          this.refresh();
        }
      } else {
        this.refresh();
      }
    }, 60000);
  },
  methods: {
    flagImage(countryName) {
      if (countryName) {
        return `${this.$store.state.screensUrl}/static/img/${countryName.toLowerCase().replace(' ', '-')}.png`;
      }

      return '';
    },
    venueDisplayName(displayname) {
      if (displayname) {
        return displayname.replace('$VE ', '').trim().toUpperCase();
      }

      return '';
    },
    raceTime(dateTime) {
      return moment.utc(dateTime).format('HH:mm');
    }
  }
};
</script>

<style>
  body {
    background-color: #000;
  }
  .flex-race-container {
    display: flex;
    flex-wrap: wrap;
  }
  .flex-race-item {
    flex-basis: 33.33333333%;
    border-right: 1px solid #000;
  }
  .venue-title-bar {
    display: flex;
    flex-direction: row;
    height: 64px;
    font-size: 40px;
    font-weight: bold;
  }
  .venue-title {

    line-height: 64px;
    padding-left: 10px;
  }
  .venue-image {
    flex-grow: 1;
    align-content: flex-end;
    text-align: right;
  }
  .venue-image img {
    height: 64px;
  }
  .the-time {
    flex-grow: 1;
    align-content: flex-end;
    line-height: 64px;
    padding-right: 10px;
    width: 160px;
    text-align: right;
  }
  .race-title-bar {
    background-color: #fb2e01;
    color: white;
    font-size: 24px;
    height: 64px;
    font-weight: bold;
  }
  .race-venue-flag {
    float: left;
    height: 64px;
  }
  .race-venue-name {
    float: left;
    margin-left: 10px;
    max-width: 225px;
    overflow: hidden;
    white-space: nowrap;
  }
  .race-name {
    line-height: 25px;
  }
  .race-container-container {
    width: 100%;
  }
  .noedge {
    border-right: 0;
  }
  .race-titles {
    float: right;
    color: #fff;
    text-align: center;
  }
  .race-places-paid {
    float: right;
    color: #fff;
    text-align: right;
    font-size: 12px;
    line-height: 64px;
    margin-left: 0;
  }
  .price-title {
    float: right;
    font-size: 10px;
    line-height: 64px;
    width: 90px;
  }
  .prev-title {
    float: right;
    font-size: 14px;
    line-height: 64px;
    width: 70px;
  }
  .place-title {
    float: right;
    font-size: 14px;
    line-height: 64px;
    width: 70px;
  }
</style>



// WEBPACK FOOTER //
// NextThree.vue?46a833b5